import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-100 image-selector" }
const _hoisted_2 = {
  key: 0,
  class: "p-inputgroup p-0 position-relative mt-auto pt-3"
}
const _hoisted_3 = { class: "p-float-label hiding position-absolute" }
const _hoisted_4 = { class: "p-floating-label" }
const _hoisted_5 = { class: "position-relative overflow-visible h-100" }
const _hoisted_6 = { class: "container-middle-start center show-first hidden" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus text-dark" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "container-middle-end center" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus text-dark" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "container-top-middle center" }
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left text-dark" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x text-light" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right text-dark" }, null, -1)
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GalleryModal = _resolveComponent("GalleryModal")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Image = _resolveComponent("Image")!
  const _component_Galleria = _resolveComponent("Galleria")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modals" }, [
      _createVNode(_component_GalleryModal, {
        id: _ctx.id + 'Selector',
        onSelect: _ctx.insertImg,
        multiple: true
      }, null, 8, ["id", "onSelect"])
    ])),
    (_ctx.currImages.length === 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t( 'editor.images' )), 1)
          ]),
          _createVNode(_component_Button, {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.setInsertId()), ["stop","prevent"])),
            icon: "bi bi-plus-lg",
            class: "p-button-outlined p-button-secondary w-100 h-100 d-flex"
          })
        ]))
      : (_openBlock(), _createBlock(_component_Galleria, {
          value: _ctx.currImages,
          key: _ctx.currImages.length
        }, {
          thumbnail: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", {
                  class: "badge-mini rounded-pill bg-white border border-1 cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.setInsertId()), ["stop","prevent"]))
                }, _hoisted_8)
              ]),
              _createVNode(_component_Image, {
                src: slotProps.item.itemSrc,
                alt: slotProps.item.alt,
                preview: true,
                class: "overflow-hidden w-100 h-100 opacity-highlight"
              }, null, 8, ["src", "alt"]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", {
                  class: "badge-mini rounded-pill bg-white border border-1 cursor-pointer",
                  onClick: _withModifiers(($event: any) => (_ctx.setInsertId(slotProps.item.positionId)), ["stop","prevent"])
                }, _hoisted_12, 8, _hoisted_10)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", {
                    class: "badge-mini rounded-pill bg-white border border-1 hide-first cursor-pointer",
                    onClick: _withModifiers(($event: any) => (_ctx.toLeft(slotProps.item.positionId)), ["stop","prevent"])
                  }, _hoisted_17, 8, _hoisted_15),
                  _createElementVNode("span", {
                    class: "badge-mini rounded-pill bg-danger border border-1 cursor-pointer",
                    onClick: _withModifiers(($event: any) => (_ctx.deleteImg(slotProps.item.positionId)), ["stop","prevent"])
                  }, _hoisted_20, 8, _hoisted_18),
                  _createElementVNode("span", {
                    class: "badge-mini rounded-pill bg-white border border-1 hide-last cursor-pointer",
                    onClick: _withModifiers(($event: any) => (_ctx.toRight(slotProps.item.positionId)), ["stop","prevent"])
                  }, _hoisted_23, 8, _hoisted_21)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["value"]))
  ]))
}